<template>
    <div class="page-wrapper bg-white radius-lg margin-left-sm flex flex-direction">
        <div class="tabs-container flex align-center">
            <div v-for="(item,index) in menus" :key="index"
                 :class="[{active:curTab === item.value},{disabled:(state === 0 || state === 1 || state === -2) && index > 1 }]" class="tab" @click="tabChange(item,index)">{{ item.label }}
            </div>
        </div>
        <div class="padding flex-sub flex flex-direction">
            <project-notice v-if="curTab === 0" :pid="pid" :readonly="readonly" :state="state" :reason="detail.remark" apply @watchState="watchState"></project-notice>
            <project-info v-if="curTab === 1" :detail="detail" :pid="pid" :readonly="readonly" @watchState="watchState"></project-info>
            <project-declaration v-if="curTab === 2" :pid="pid" :readonly="readonly" :state="state" :reason="detail.remark" apply @watchState="watchState"></project-declaration>
            <project-materials v-if="curTab === 3" :pid="pid"  :readonly="readonly" :state="state" :reason="detail.remark"  @watchState="watchState"></project-materials>
        </div>
    </div>
</template>

<script>

import {apply_project_menus} from "@/utils/const";
import {getApplyProjectDetail} from "@/api";
import ProjectNotice from "@/views/web/staff/page/apply/components/ProjectNotice";
import ProjectInfo from "@/views/web/staff/page/apply/components/ProjectInfo";
import ProjectDeclaration from "@/views/web/staff/page/apply/components/ProjectDeclaration";
import ProjectMaterials from "@/views/web/staff/page/apply/components/ProjectMaterials";

export default {
    name: "project-apply-review",
    components: {ProjectMaterials, ProjectDeclaration, ProjectInfo, ProjectNotice},
    data() {
        return {
            pid: 0,
            title: '项目申报',
            menus: apply_project_menus,
            curTab: 0,
            detail: '',
            state: 0,//            //0 1提交审核 2通过 -2拒绝 3提交审核 4通过-4拒绝
            readonly: true,
        }
    },
    created() {
        this.pid = Number(this.$route.params.id || 0)
        this.curTab = Number(this.$route.params.menu || 0)
        if (this.pid) this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async init() {
            let _data = await getApplyProjectDetail(this.pid)
            this.title = _data.data.p_name
            this.detail = _data.data
            this.state = _data.data.state || 0
            this.$emit('setIndex', [1,3], this.title, true)
        },
        tabChange(item, index) {
            if ((this.state === 0 || this.state === 1 || this.state === -2) && index > 1) return
            this.curTab = item.value
        },
        watchState(data) {
            if (data) this.init()
        }
    }

}
</script>

<style lang="scss" scoped>
.page-wrapper {
}
</style>
